import React from 'react';
import Route from 'react-router/lib/Route';
import store from 'store';
import IndexRoute from 'react-router/lib/IndexRoute';

// actions
import {
  handleRegistrationHomeRouteEnter,
  handleRegistrationScheduleRouteEnter,
  handleAccountCreatedRouteEnter,
  handleRegistrationCheckoutRouteEnter,
  handleRegistrationManageRouteEnter,
  handleRegistrationCheckoutRosterRouteEnter
} from './actions';

// actionTypes
import {setPaymentMessage} from './home/actionTypes';

// components
import RegHomeContainer from './home/RegHomeContainer.jsx';
import AccountCreatedContainer from './accountCreated/AccountCreatedContainer.jsx';
import SchedulerContainer from './scheduler/SchedulerContainer.jsx';
import CheckoutContainer from './checkout/CheckoutContainer.jsx';
import CheckoutRosterContainer from './rostercheckout/CheckoutRosterContainer.jsx';
import ManageContainer from './manage/ManageContainer.jsx';

const routes = (
  <div>
    <IndexRoute component={RegHomeContainer}
      onEnter={(nextState, replace, callback) =>
        store.dispatch(handleRegistrationHomeRouteEnter(nextState, replace, callback))}
    />
    <Route path="registration"
      component={RegHomeContainer}
      onEnter={(nextState, replace, callback) =>
        store.dispatch(handleRegistrationHomeRouteEnter(nextState, replace, callback))}
      onLeave={() => store.dispatch(setPaymentMessage(''))}
    />
    <Route path="registration/schedule/:tournamentId"
      component={SchedulerContainer}
      onEnter={(nextState, replace, callback) =>
        store.dispatch(handleRegistrationScheduleRouteEnter(nextState, replace, callback))}
    />
    <Route path="registration/accountCreated"
      component={AccountCreatedContainer} 
      onEnter={(nextState, replace, callback) =>
        store.dispatch(handleAccountCreatedRouteEnter(nextState, replace, callback))}
    />
    <Route path="registration/checkout/:tournamentId"
      component={CheckoutContainer}
      onEnter={(nextState, replace, callback) =>
        store.dispatch(handleRegistrationCheckoutRouteEnter(nextState, replace, callback))}
    />
    <Route path="registration/checkout/:tournamentId/:paymentId"
      component={CheckoutContainer}
      onEnter={(nextState, replace, callback) =>
        store.dispatch(handleRegistrationCheckoutRouteEnter(nextState, replace, callback))}
    />
    <Route path="registration/manage/:tournamentId"
      component={ManageContainer}
      onEnter={(nextState, replace, callback) =>
        store.dispatch(handleRegistrationManageRouteEnter(nextState, replace, callback))}
    />
    <Route path="registration/manage/:tournamentId/:paymentId"
      component={ManageContainer}
      onEnter={(nextState, replace, callback) =>
        store.dispatch(handleRegistrationManageRouteEnter(nextState, replace, callback))}
    />
    <Route path="registration/rostercheckout/:tournamentId"
        component={CheckoutRosterContainer}
        onEnter={(nextState, replace, callback) =>
        store.dispatch(handleRegistrationCheckoutRosterRouteEnter(nextState, replace, callback))}
    />
  </div>
);

export default routes;



// WEBPACK FOOTER //
// ./src/features/registration/routes.js